import * as Yup from "yup";

const nfEntradaItemObjectXmlValidator = Yup.object().shape({
  tipo: Yup.string().required(),
  codigoBarra: Yup.string().nullable(),
  descricao: Yup.string().required(),
  unidadeComercialCompraId: Yup.number().nullable(),
  conversorEntrada: Yup.number().nullable(),
  fracionavel: Yup.string().nullable(),
  precoCompra: Yup.number().nullable(),
  grupoProdutoId: Yup.number().required("Grupo de Produto"),
  grupoTributacaoId: Yup.number().required("Grupo tributário"),
  generoItemId: Yup.number().nullable(),
  tipoItemId: Yup.number().nullable(),
  origemMercadoriaId: Yup.number().required("Origem Mercadoria Id"),
  ncmId: Yup.number().required("NCM ID"),
  ncmCodigo: Yup.string()
    .min(8, "NCM deve ter pelo menos 8 caracteres")
    .required("NCM Código"),
  cestId: Yup.number().nullable(),
  cfopId: Yup.number().nullable().required("CFOP"),
  informacaoAdicionalNfe: Yup.string().nullable(),
});

const nfEntradaItensXmlValidator = Yup.object().shape({
  itens: Yup.array()
    .of(nfEntradaItemObjectXmlValidator)
    .min(1, "Adicione ao menos um item")
    .required("Adicione ao menos um item"),
});

export default nfEntradaItensXmlValidator;
